module.exports = __webpack_public_path__ + "img/laptop-over-charts.3281730d.png";